const ENDPOINTS = {
    PRE_LAND_IOS1: 'ios1',
    PRE_LAND_IOS2: 'ios2',
    PRE_LAND_IOS3: 'ios3',
    PRE_LAND_IOS4: 'ios4',
    PRE_LAND_IOS5: 'ios5',
    PRE_LAND_IOS6: 'ios6',
    PRE_LAND_IOS7: 'ios7',
};

export default ENDPOINTS;
